export const environment = {
    production: false,
    //base_url: 'https://ws-toyosa.toyosa-test.com/api/v1',
    base_url: 'https://ws-toyosa.toyosaapis.com/api/v1',
    api_key_maps: 'AIzaSyCDcX8QUnzQp3QknpVdWfs7k-hEMW4RS7g',
    recaptcha: {
        siteKey: '6LcCEw0TAAAAAKoeyWMIteGc_-6AiOVBa8cUb3ME',
    }
};
